import joi from "joi";

import { schemaItem } from "./purchaseOrderItem.schema.js";

const constants = {
    catIncoterms: [
        "CFR",
        "CIF",
        "CIP",
        "CPT",
        "DAP",
        "DAT",
        "DDP",
        "DPU",
        "EXW",
        "FAS",
        "FCA",
        "FOB",
    ],
    catPriority: ["1", "0"],
};
export const schemaPO = joi.object({
    PONumber: joi.string().required().max(30),
    supplierCode: joi.string().max(20).allow(null, ''),
    supplierName: joi.string().required().max(255),
    supplierAddress: joi.string().max(255).allow('', ' '),
    supplierContactName: joi.string().max(255).allow('', ' '),
    consigneeCode: joi.string().max(20).allow(null, ''),
    consigneeName: joi.string().required().max(255),
    consigneeAddress: joi.string().max(255).allow('', ' '),
    consigneeContactName: joi.string().max(255).allow('', ' '),
    deliveryCode: joi.string().max(20).allow('', ' '),
    deliveryName: joi.string().max(255).allow('', ' '),
    deliveryAddress: joi.string().max(255).allow('', ' '),
    deliveryContactName: joi.string().max(255).allow('', ' '),
    pickupAddress: joi.string().max(300).allow('', ' '),
    deliveryToAddress: joi.string().max(300).allow('', ' '),
    productType: joi.string().max(50).allow('', ' '),
    division: joi.string().max(50).allow('', ' '),
    originCountry: joi.string().max(20).allow('', ' '),
    customerReference: joi.string().max(200).allow('', ' '),
    buyer: joi.string().max(50).allow('', ' '),
    orderValue: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    POCreationDate: joi.date().required().allow(null),
    requestedCargoReady: joi.date().allow(null, ''),
    requiredAtDestination: joi.date().allow(null, ''),
    orderCurrency: joi.string().max(10).allow('', ' '),
    priorityPO: joi.string().valid(...constants.catPriority).allow('', ' '),
    originZipCode: joi.string()
        .regex(/^[a-zA-Z0-9-_]*$/)
        .max(10)
        .min(4)
        .required(),
    destinationZipCode: joi.string()
        .regex(/^[a-zA-Z0-9-_]*$/)
        .max(10)
        .min(4)
        .required(),
    incoterms: joi.string()
        .length(3)
        .regex(/^[A-Z]{3}$/)
        .uppercase()
        .valid(...constants.catIncoterms, null)
        .allow(null),
    OriginEntry: joi.string().max(50).allow('', ' '),
});

export const schemaFull = joi.object({
    PO: schemaPO.required(),
    POItems: joi.array().items(schemaItem).min(1).required(),
});
